import styled from 'styled-components'

import { theme } from '../../constants'

export const TooltipRoot = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
`

export const TooltipTrigger = styled.button`
  width: ${theme.layout.controlHeight};
  height: ${theme.layout.controlHeight};
  display: inline-grid;
  padding: 0;
  place-items: center;
  color: ${theme.colors.textSecondary};
  background: transparent;
  border: 0;
  border-radius: ${theme.radii.round};
  font: inherit;
  cursor: help;
  transition:
    color ${theme.motion.fast} ${theme.motion.easing},
    background ${theme.motion.fast} ${theme.motion.easing};

  &:hover,
  &[aria-expanded='true'] {
    color: ${theme.colors.textPrimary};
    background: ${theme.colors.backgroundGrey};
  }

  &:focus-visible {
    outline: 3px solid ${theme.semanticColors.focus};
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const TooltipPanel = styled.div<{
  $left: number
  $placement: 'top' | 'bottom'
  $top: number
}>`
  position: fixed;
  z-index: 1000;
  left: ${({ $left }) => `${$left}px`};
  top: ${({ $top }) => `${$top}px`};
  width: min(296px, calc(100vw - ${theme.spacing[8]}));
  padding: ${theme.spacing[3]} ${theme.spacing[4]};
  color: ${theme.colors.textPrimary};
  background: ${theme.colors.surfaceElevated};
  border: 1px solid ${theme.colors.borderStrong};
  border-radius: ${theme.radii.medium};
  box-shadow: ${theme.shadows.medium};
  font-size: ${theme.typography.size.caption};
  line-height: ${theme.typography.lineHeight.body};
  pointer-events: none;
  transform: ${({ $placement }) =>
    $placement === 'top'
      ? `translate(-50%, calc(-100% - ${theme.spacing[2]}))`
      : `translate(-50%, ${theme.spacing[2]})`};

  strong {
    display: block;
    margin-bottom: ${theme.spacing[1]};
    color: ${theme.colors.textPrimary};
    font-size: ${theme.typography.size.bodySmall};
  }

  ul {
    display: grid;
    gap: ${theme.spacing[1]};
    margin: 0;
    padding-left: ${theme.spacing[4]};
  }
`
